module.exports = new __parcel__URL__("squid.0638299b.svg").toString();